if (sessionStorage["ipCountryCode"] == null || sessionStorage["ipCountryCode"] == 'null' || sessionStorage["ipCountryCode"] == "undefined" || sessionStorage["timezone"] == null || sessionStorage["timezone"] == "undefined") {
    fetch("https://ipinfo.io/json?token=12e8178bc24f84")
        .then(function (response) {
            return response.ok ? response.json() : null;
        })
        .then(function (data) {
            sessionStorage["ipCountryCode"] = (data && data.country) || null;
            sessionStorage["timezone"]      = (data && data.timezone) || null;
        })
        .catch(function () {
            // ipinfo indisponible / quota : la géoloc IP est non-critique, on n'émet pas d'exception
        })
}

/*
Token Léa :12e8178bc24f84
Token Antoine : 8521ad5bc8e785
Token Charly :353b8251a2c69a
Token Owen : f2012060130eff
*/
